import { getTokensFromCookies } from './AuthApi';

// api/websocket.js
let socket = null;
let reconnectTimeout = null;
let listeners = [];
const BASE_WS_URL = window?.APP_CONFIG?.SOCKET_DOMAIN;

function connectWebSocket(path = '') {
  if (socket) return; // Уже подключен
  const { a_token } = getTokensFromCookies();

  const url = `${BASE_WS_URL}/${path}`.replace(/([^:]\/)\/+/g, '$1');

  if (!a_token) {
    return;
  }
  socket = new WebSocket(url, [
    'Bearer',
    `${a_token ? encodeURIComponent(a_token) : ''}`,
  ]);

  socket.onopen = () => {
    // console.log('WebSocket connected to', url);
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      listeners.forEach((cb) => cb(data));
    } catch (err) {
      console.error('Error parsing WebSocket message:', err);
    }
  };

  socket.onerror = (error) => {
    console.error('WebSocket error:', error);
  };

  socket.onclose = () => {
    console.log('WebSocket disconnected, reconnecting...');
    socket = null;
    reconnectTimeout = setTimeout(() => connectWebSocket(path), 3000);
  };
}

function disconnectWebSocket() {
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
    reconnectTimeout = null;
  }
  if (socket) {
    socket.close();
    socket = null;
  }
}

function sendMessage(message) {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message));
    return true;
  }
  console.error('WebSocket is not connected');
  return false;
}

function addMessageListener(callback) {
  listeners.push(callback);
  return () => {
    listeners = listeners.filter((cb) => cb !== callback);
  };
}

function isConnected() {
  return socket && socket.readyState === WebSocket.OPEN;
}

export const websocketApi = {
  connect: connectWebSocket,
  disconnect: disconnectWebSocket,
  send: sendMessage,
  subscribe: addMessageListener,
  isConnected,
};
